import React, { useState } from 'react';
import axios from 'axios';
import { UserCircleGear, X } from '@phosphor-icons/react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BulkOwnerBar = ({ selectedIds, tenderExecs, onDone, onClear }) => {
  const [owner, setOwner] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');

  const apply = async () => {
    if (owner === '') return;
    setBusy(true);
    setMsg('');
    try {
      const r = await axios.post(`${API}/tenders/bulk-owner`, {
        tender_ids: selectedIds,
        owner_te_id: owner === '__none__' ? null : owner,
      });
      setMsg(`Updated ${r.data.updated}${r.data.unchanged ? ` · ${r.data.unchanged} already set` : ''}`);
      setOwner('');
      onDone?.();
    } catch (e) {
      setMsg(e.response?.data?.detail || 'Bulk assign failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="sticky top-2 z-20 mb-3 flex flex-wrap items-center gap-3 rounded-xl bg-[#052A23] text-white px-4 py-2.5 shadow-lg"
      style={{ animation: 'fadeUp .2s ease both' }}
      data-testid="tender-bulk-bar"
    >
      <style>{'@keyframes fadeUp{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}'}</style>
      <span className="text-sm font-semibold" data-testid="tender-bulk-count">{selectedIds.length} selected</span>
      <UserCircleGear size={16} className="text-[#9FD9CF]" />
      <select
        value={owner}
        onChange={(e) => setOwner(e.target.value)}
        className="text-sm px-2 py-1.5 rounded-lg bg-white text-[#052A23]"
        data-testid="tender-bulk-owner-select"
      >
        <option value="">Assign owner…</option>
        <option value="__none__">— Unassigned —</option>
        {tenderExecs.map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}
      </select>
      <button
        onClick={apply}
        disabled={busy || owner === ''}
        className="text-sm px-3 py-1.5 rounded-lg bg-[#00a69c] font-semibold hover:bg-[#00bfb3] disabled:opacity-50 transition-colors"
        data-testid="tender-bulk-apply"
      >
        {busy ? 'Applying…' : 'Apply'}
      </button>
      {msg && <span className="text-xs text-[#9FD9CF]" data-testid="tender-bulk-msg">{msg}</span>}
      <button onClick={onClear} className="ml-auto p-1 rounded hover:bg-white/10" title="Clear selection" data-testid="tender-bulk-clear">
        <X size={14} />
      </button>
    </div>
  );
};
